import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginGuard } from '../auth/loginGuard';
import { AgencyLayoutComponent } from './agency-layout/agency-layout.component';
import { AgencyDashboardComponent } from './agency-dashboard/agency-dashboard.component';
import { AgenciesComponent } from './agencies/agencies.component';
import { MembersSearchComponent } from './members-search/members-search.component';
import { AgencyEmployeeComponent } from './agency-employee/agency-employee.component';

const routes: Routes = [
  {
    path: 'agency',
    component: AgencyLayoutComponent,
    children: [
      { path: '', redirectTo: "/agency/dashboard", pathMatch: "full" },
      {
        path: 'dashboard',
        component: AgencyDashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'employers-list',
        component: AgenciesComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'members-patient',
        component: MembersSearchComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'employee-list',
        component: AgencyEmployeeComponent,
        canActivate: [LoginGuard],
      }
    ]
  }];

@NgModule({
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgencyRoutingModule { }
